interface CaptionProps {
    text: string;
    bold?: boolean;
    cls?: string;
}

const Caption = ({ text, bold, cls = '' }: CaptionProps) => (
    <figcaption className={cls}>{bold ? <strong>{text}</strong> : text}</figcaption>
);

export default Caption;
